/** Тик опроса пропускается в скрытой вкладке браузера. */
export const skipHiddenPagePoll = (): boolean =>
  typeof document !== "undefined" && document.visibilityState === "hidden";
